interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-20 bg-background-100 rounded-lg border border-dashed border-background-300">
      <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mb-5">
        <i className="ri-search-eye-line text-2xl text-foreground-400"></i>
      </div>
      <h3 className="font-heading text-lg text-foreground-800">{title}</h3>
      {description && (
        <p className="text-sm text-foreground-500 mt-2 max-w-md font-body px-4">
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-body hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}